import { makeStyles } from '@material-ui/core/styles';

import { COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: 450,
      padding: theme.spacing(2.25),
      backgroundColor: COLORS.primary.default,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      '&::after': {
        content: "''",
        position: 'absolute',
        right: '-15px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '0',
        height: '0',
        borderTop: '15px solid transparent',
        borderBottom: '15px solid transparent',
        borderLeft: `15px solid ${COLORS.primary.default}`,
      },
    },
    title: {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.pxToRem(21),
      lineHeight: theme.typography.pxToRem(31),
      color: COLORS.neutral.white,
      fontFamily: FONTS.DMSans,
      marginBottom: theme.spacing(1),
    },
    description: {
      fontSize: theme.typography.pxToRem(14),
      color: COLORS.neutral.silver,
      lineHeight: 1.4,
      marginBottom: theme.spacing(2.6),
    },
    button: {
      marginLeft: 'auto',
      backgroundColor: COLORS.gray.gray90,
      color: COLORS.primary.default,
      width: 158,
    },
  }),
  { name: 'ScoreOnboardingHint' }
);
